import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'sg-data-box',
  templateUrl: 'data-box.component.html',
  styleUrls: ['data-box.component.scss'],
  standalone: false,
})
export class SgDataBoxComponent {
  @Input() isLoading = false;
  @Input() data: string | number = 'No Data';
  @Input() iconName: string = 'loans';
  @Input() iconColor: string = '#344f66';
  @Input() iconBackgroundColor: string = '#e8eff9';
  @Input() dataColor: string = '#344f66';
  @Input() title: string = 'Empty Title';

  constructor() {}
}
